
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from '../../shared/service/shared.service';
import { CancelProcessRequest, CancelProcessResponse, ProcessItem } from '../../shared/models/process.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

/** String resource — boşsa Türkçe varsayılan; değerler mevcut DB anahtarlarıyla uyumlu */
const CANCEL_PROCESS_KEYS = {
    title: 'cancelProcess_Title',
    text: 'cancelProcess_Text',
    reason: 'cancelProcess_Reason',
    warning: 'cancelProcess_Warning',
    abandon: 'cancelProcess_Abandon',
    cancel: 'cancelProcess_Cancel',
    close: 'cancelProcess_Close',
    processType1: 'cancelProcess_ProcessType1',
    processType2: 'cancelProcess_ProcessType2',
    result1: 'cancelProcess_Result1',
    result2: 'cancelProcess_Result2',
    statusWarning: 'cancelProcess_StatusWarning',
};

@Component({
    selector: 'cancel-process',
    templateUrl: './cancel-process.component.html',
    styleUrls: ['./cancel-process.component.css']
})
export class CancelProcessComponent extends SiriusBaseComponent<any> {
    @Input('SelectedProcess') selectedProcess: ProcessItem;
    @Output('OnProcessCancel') onProcessCancel = new EventEmitter<void>();

    @ViewChild("cancelTemplate") cancelTemplate: TemplateRef<any>;

    pageIndex: number = 0;
    cancelReasonForm: FormGroup;
    resultMessage: string;
    result: boolean;

    modalRef: BsModalRef;

    cancelProcess_Title = 'İşlem İptali';
    cancelProcess_Text = '';
    cancelProcessTextTemplate = 'İşleminizi iptal etmek üzeresiniz. Referans: {referenceId}';
    cancelProcess_Reason = 'İptal gerekçesi';
    cancelProcess_Warning = 'İptal gerekçesi zorunludur.';
    cancelProcess_Abandon = 'Vazgeç';
    cancelProcess_Cancel = 'İptal Et';
    cancelProcess_Close = 'Kapat';
    cancelProcess_ProcessType1 = 'SATIŞ';
    cancelProcess_ProcessType2 = 'ALIŞ';
    cancelProcess_Result1 = 'İşlem iptal edilemedi.';
    cancelProcess_Result2 = 'İşlem başarıyla iptal edildi.';
    cancelProcess_StatusWarning = 'Bu işlem durumunda iptal yapılamaz.';
    constructor(private commonService: CommonService,
      private modalService: BsModalService) {
        super();
    }
    OnInit() {
        this.loadCancelProcessResourceStrings();
        this.cancelReasonForm = new FormGroup({
            'cancelReason': new FormControl("", [Validators.required])
        });
    }

    private loadCancelProcessResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);

        this.cancelProcess_Title = r(CANCEL_PROCESS_KEYS.title, this.cancelProcess_Title);
        this.cancelProcessTextTemplate = r(CANCEL_PROCESS_KEYS.text, this.cancelProcessTextTemplate);
        this.cancelProcess_Reason = r(CANCEL_PROCESS_KEYS.reason, this.cancelProcess_Reason);
        this.cancelProcess_Warning = r(CANCEL_PROCESS_KEYS.warning, this.cancelProcess_Warning);
        this.cancelProcess_Abandon = r(CANCEL_PROCESS_KEYS.abandon, this.cancelProcess_Abandon);
        this.cancelProcess_Cancel = r(CANCEL_PROCESS_KEYS.cancel, this.cancelProcess_Cancel);
        this.cancelProcess_Close = r(CANCEL_PROCESS_KEYS.close, this.cancelProcess_Close);
        this.cancelProcess_ProcessType1 = r(CANCEL_PROCESS_KEYS.processType1, this.cancelProcess_ProcessType1);
        this.cancelProcess_ProcessType2 = r(CANCEL_PROCESS_KEYS.processType2, this.cancelProcess_ProcessType2);
        this.cancelProcess_Result1 = r(CANCEL_PROCESS_KEYS.result1, this.cancelProcess_Result1);
        this.cancelProcess_Result2 = r(CANCEL_PROCESS_KEYS.result2, this.cancelProcess_Result2);
        this.cancelProcess_StatusWarning = r(CANCEL_PROCESS_KEYS.statusWarning, this.cancelProcess_StatusWarning);
    }
    cancelProcess() {
        if (this.cancelReasonForm.valid) {
            var cancelProcessInfo: CancelProcessRequest = {
                FirmReference: this.selectedProcess.FirmReference,
                CancelReason: this.cancelReasonForm.controls.cancelReason.value,
            }
            var promise = this.commonService.CancelProcess(this.dataService, cancelProcessInfo);
            promise.then((result: CancelProcessResponse) => {
                this.pageIndex = 1;
                if (result == null || result.InfoMessageId == 0) {
                    this.result = false;
                    if (result.ErrorMessage != null && result.ErrorMessage != "") {
                        this.resultMessage = result.ErrorMessage;
                    }
                    else {
                        this.resultMessage = this.cancelProcess_Result1;
                    }
                }
                else {
                    this.resultMessage = this.cancelProcess_Result2;
                    this.result = true;
                    this.onProcessCancel.emit();
                }
            }, (error) => {
                this.pageIndex = 1;
                this.resultMessage = this.cancelProcess_Result1;
                this.result = false;
            });
        }
        else {
            this.cancelReasonForm.controls.cancelReason.markAsTouched();
        }  
    }
    showPopup() {
      this.initPopup();
      this.modalRef = this.modalService.show(this.cancelTemplate);
  }
  closePopup() {
    this.modalRef.hide();
  }
    initPopup() {      
        if (this.selectedProcess.ProcessStatus == "5") {
            this.pageIndex = 1;
            this.resultMessage = this.cancelProcess_StatusWarning;
            this.result = false;
        }
        else {
            this.pageIndex = 0;
            this.resultMessage = "";
            this.result = false;
            this.cancelReasonForm.reset();
            this.cancelProcess_Text = this.commonService.prepareStringText(this.cancelProcessTextTemplate,
                [{ key: 'referenceId', value: this.selectedProcess.FirmReference, bold: true }]);
        }
    }
}
